import { gql } from '@apollo/client';
import { WarehouseLocationScanResponse } from '../queries/warehouseQueries';

export const HANDLE_PUTAWAY_SCAN_EVENT = gql`
  mutation HandlePutawayScanEvent($trackingNumber: String!, $locationNo: String!, $confirmPutaway: Boolean!) {
    handlePutawayScanEvent(trackingNumber: $trackingNumber, locationNo: $locationNo, confirmPutaway: $confirmPutaway) {
      success
      messageKey
      requireConfirmation
      packageInfo {
        locationId
        locationNo
        trackingNumber
        locationOrderNo
      }
    }
  }
`;

export interface HandlePutawayScanEventResponse {
  handlePutawayScanEvent: WarehouseLocationScanResponse;
}

export interface HandlePutawayScanEventVariables {
  trackingNumber: string;
  locationNo: string;
  confirmPutaway: boolean;
}
